import { TListResponse } from 'src/common/types';
import { TTableSort, TTableSortCols } from 'src/components/table/thead/col';


export const ApplicationListSourceSortCol = {
	ID: 'id',
	NAME: 'name',
	UPDATED_AT: 'updated_at',
	CREATED_AT: 'created_at',
};

export type TApplicationListSourceSortCol = TTableSortCols<typeof ApplicationListSourceSortCol>;

export type TApplicationSourceQuery = {
	limit: number;
	offset: number;
	search?: string;
	sort?: TTableSort;
	sortCol?: TApplicationListSourceSortCol;
};

export type TApplicationListSourceQueryRequest = {
	limit?: number;
	offset?: number;
	search?: string;
	sort?: string;
	sort_col?: string;
};

export function adaptApplicationListSourceQueryToRequest(data?: TApplicationSourceQuery): TApplicationListSourceQueryRequest {
	if (!data) {
		return {};
	}

	const {
		sortCol,
		...restFields
	} = data;

	return {
		sort_col: sortCol,
		...restFields
	};
}

export type TApplicationSource = {
  id: number;
  name: string;
};

export type TApplicationSourceResponse = TApplicationSource;

export type TApplicationSourceListResponse = TListResponse<TApplicationSourceResponse>;

export type TApplicationSourceList = TListResponse<TApplicationSource>;

export function adaptApplicationSourceFromListResponse(data: TApplicationSourceListResponse): TApplicationSourceList {
	const {
		items: itemsRaw = [],
		...restFields
	} = data;

	const items = itemsRaw.map(item => adaptApplicationSourceFromResponse(item));

	return {
		items,
		...restFields
	};
}

export function adaptApplicationSourceFromResponse(data: TApplicationSourceResponse): TApplicationSource {
	const {
		id,
		name,
	} = data;

	return {
		id,
		name,
	};
}
